import type { KeyboardAwareScrollViewProps } from "react-native-keyboard-controller";
import {
  KeyboardAvoidingView,
  KeyboardAwareScrollView,
  KeyboardToolbar,
} from "react-native-keyboard-controller";
import { cssInterop } from "nativewind";

cssInterop(KeyboardAvoidingView, {
  className: {
    target: "style",
  },
});

cssInterop(KeyboardAwareScrollView, {
  className: {
    target: "style",
  },
  contentContainerClassName: {
    target: "contentContainerStyle",
  },
});

export { KeyboardAvoidingView, KeyboardAwareScrollView, KeyboardToolbar };
export type { KeyboardAwareScrollViewProps };
